import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-193">
      {/* Overlay */}
      <div className="absolute inset-0 bg-olive/60 backdrop-blur-sm" onClick={onClose} data-id="element-194" />

      {/* Modal Card */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col animate-[fadeInUp_0.3s_ease-out]" data-id="element-195">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-sage/20" data-id="element-196">
          <h2 className="text-2xl font-serif font-bold text-olive" data-id="element-197">{title}</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-light-sage transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-terra" aria-label="Cerrar" data-id="element-198">
            <XIcon className="w-5 h-5 text-olive" data-id="element-199" />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="p-6 overflow-y-auto text-olive/80 leading-relaxed space-y-4" data-id="element-200">
          {children}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-sage/20 text-center" data-id="element-201">
          <button onClick={onClose} className="px-6 py-2 bg-sage text-white rounded-full text-sm font-semibold hover:bg-olive transition-colors duration-200" data-id="element-202">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}